export const removeTrailingZeros = (price: string) => {
  const newPrice = price?.replace('.00', '') || price;
  return newPrice;
};

export const formatPriceUnit = (price: number, country: string) => {
  const formattedPrice =
    country === 'SE' || country === 'NO' ? `${price} kr` : `€${price}`;
  return removeTrailingZeros(formattedPrice);
};
